import { inArticleCommonConfig } from './common-config-in-article-video';
import { unmarshaller as expandBtnConfig } from './expand-buton-config';

export const inArticleLandscapeConfig = {
  ...inArticleCommonConfig,
  ...expandBtnConfig
};
